import PropTypes from 'prop-types';
import BasicModal from 'js/common/components/basic_modal';

const { LP } = window;

const LockedFacetModal = ({
  handleClose,
  className,
  title,
  iconsHtml,
  precedingText,
  succeedingText,
  linkText
}) => {
  return (
    <BasicModal.Container
      id="lockout-experience-modal"
      onClose={handleClose}
      className={`${className} lockout-modal`}
    >
      <BasicModal.Header onClose={handleClose}>
        <div className="lockout-modal-icons">{iconsHtml}</div>
        <div className="lockout-modal-text">
          {precedingText}
          <span className="lockout-provider-name">{title}</span>
          {succeedingText}
        </div>
        <a
          data-remote="true"
          className="lockout-modal-button btn btn-success"
          onClick={handleClose}
          href={LP.config.new_subscription_path}
        >
          {linkText}
        </a>
      </BasicModal.Header>
    </BasicModal.Container>
  );
};

LockedFacetModal.propTypes = {
  handleClose: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string,
  iconsHtml: PropTypes.object,
  precedingText: PropTypes.object,
  succeedingText: PropTypes.object,
  linkText: PropTypes.string
};

LockedFacetModal.defaultProps = {
  className: 'lockout-experience-modal',
  iconsHtml: (
    <div>
      <i className="first-icon fa-regular fa-file-lines"></i>
      <i className="second-icon fa-regular fa-file-lines"></i>
    </div>
  ),
  precedingText: (
    <span>
      Get access to more than
      <br />
      200k resources with
      <br />
    </span>
  ),
  succeedingText: (
    <span>
      <br />
      our newest content partner.
    </span>
  ),
  linkText: 'Get Full Access Now'
};

// For Boclips
LP.module('Searches').LockedFacetModal = LockedFacetModal;

export default LockedFacetModal;
